import { Box, Text, calcs } from "grommet";
import React, { CSSProperties } from "react";
import { StyleSheet } from "../../../../../../../typings/StyleSheet";
import StandardColors from "../../../../../../../util/StandardColors";
import StandardFonts from "../../../../../../../util/StandardFonts";
import TitleText from "./TitleText";
import './PropertyDisplayField.css';
import gender from "../../../../../../../assets/gender.png";

type PropertyDisplayFieldPropsType = {
  title: string;
  value?: string;
  valueComponent?: React.ReactNode;
  style?: CSSProperties;
  symbol?: string
};

const PropertyDisplayField = ({
  title,
  value,
  valueComponent,
  style,
  symbol
}: PropertyDisplayFieldPropsType) => {
  return (
    <Box style={{ ...styles.container, ...style }} className="passengerInfoCard">
      <Box style={styles.labels}>
        {
          symbol &&
            <Box style={{...styles.icon}}>
              <img
                src={symbol}
                style={{ width: 16, height: 16, objectFit: "cover" }}
              />
            </Box>
        }
        <Box style={styles.passengerDetail}>
          <TitleText parentInfo="passInfo" title={title} />
        </Box>
      </Box>
        <Text style={styles.value}>{value}</Text>
    </Box>
  );
};

export default PropertyDisplayField;

const styles: StyleSheet = {
  labels: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  icon: {
    display: 'flex',
    flexDirection: 'row',
    width: 28,
    height: 28,
    padding: '1px 2px',
    alignItems: 'center',
    justifyContent: "center",
    borderRadius: 48,
    backgroundColor: "#F2F7FF",
    marginRight: 10
  },
  container: {
    display: "flex",
    alignItems: "center",
    borderRadius: 12,
    flexDirection: "row",
    justifyContent: 'space-between',
    width: 'auto',
    minHeight: "unset"
  },
  value: {
    color: "#4B628A",
    fontFamily: "Inter",
    fontSize: 14,
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "16px"
  },
  value2: {
    color: "#A7B6D1",
    fontFamily: "Inter",
    fontSize: 10,
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "14px",
    marginLeft: 10
  },
  passengerDetail: {
    display: 'flex',
    flexDirection: 'row'
  }
};
